import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import { QRCodeSVG } from "qrcode.react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import { LuImage, LuPenTool } from "react-icons/lu";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Typography from "@mui/material/Typography";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import Allgemein from "../Tabs/TabContent-Details/Allgemein";
import tabsStore from "../../Stores/TabsStore";
import tabsConstants from "../../Constants/TabsConstants";
import TabsActions from "../../Actions/TabsActions";
import ViewChecklist from "./ViewChecklists";
import FormTicketRaise from "./FormTicketRaise";

import {
  useEquipGrpPublicInfoActionsContext,
  useEquipGrpPublicInfoContext,
} from "../../Context/EquipGroupPublicInfoContext";
import AddMaintenance from "./AddMaintenance";
import { toast } from "react-toastify";
const EquipmentDetailOverview = ({
  anlageid,
  handleTourGuid,
  handleTabSelection,
}) => {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [isEdit, setIsEdit] = useState(false);
  const [viewChecklist, setViewChecklist] = useState(false);
  const [selectedEquipDetail, setSelectedEquipDetail] = useState("");
  const [openTicketModal, setOpenTicketModal] = useState(false);
  const equipGroupPublicWebConf = useEquipGrpPublicInfoContext();
  const getEquipmentGroupPublicInfo = useEquipGrpPublicInfoActionsContext();
  const [isMaxTicketLimitReach, setIsMaxTicketLimitReach] = useState(false);
  const [openAddMaintenance, setOpenAddMaintenance] = useState(false);
  const [totalImageCount, setTotalImageCount] = useState("");
  const [tag, setTag] = useState("");
  const qrCodeRef = useRef(null);

  const [detailAttrList, setDetailAttributeList] = useState({
    title: localization.equipmentInfo,
    description: localization.coreDetails,
    itemList: [],
  });
  const [tickeList, setTicketList] = useState({
    title: localization.openTicketsTitle,
    description: "",
    itemList: [],
  });
  const [maintenanceList, setMaintenanceList] = useState({
    title: localization.upcomingMaintenanceTitle,
    description: "",
    itemList: [],
  });
  const [equipImageData, setEquipmentImageData] = useState([]);

  useEffect(() => {
    if (anlageid !== null && anlageid !== undefined) {
      setGlobalSpinner(true);
      TabsActions.getEquipmentOverviewDetails(anlageid);
      getEquipmentGroupPublicInfo(anlageid);
    }
    return () => {};
  }, [anlageid]);

  useEffect(() => {
    function updateData() {
      var res = tabsStore.getResult();
      if (res) {
        let tempObj1 = { ...detailAttrList };
        tempObj1.itemList = res.attributes?.map((item, index) => {
          return {
            label: item.id,
            value: item.text,
            cssClass: "",
          };
        });

        let tempObj2 = { ...tickeList };
        tempObj2.itemList = res.tickets?.map((item, index) => {
          return {
            label: item.title,
            value: item.priority,
            Created: localization.createdOn + ": " + item.createdOn,
            cssClass:
              item.priority.toLowerCase() == "high"
                ? "priorityCls highPriority"
                : item.priority.toLowerCase() == "medium"
                  ? "priorityCls mediumPriority"
                  : "priorityCls lowPriority",
          };
        });

        let tempArr = [];
        var isDefaultImagePresent = false;
        var tempImageCountArray = res.photos.filter((item, index) => {
          return item.documentAsString != null && item.documentAsString != "";
        });
        setTotalImageCount(tempImageCountArray.length);
        res.photos.map((item, index) => {
          if (item.isDefualt) {
            isDefaultImagePresent = true;
            tempArr.push(item);
          }
        });

        if (!isDefaultImagePresent) {
          tempArr = res.photos.filter((item, index) => {
            return item.documentAsString != null && item.documentAsString != "";
          });
        }

        let tempObj3 = { ...maintenanceList };
        tempObj3.itemList = res.maintenances?.map((item, index) => {
          return {
            label: item.bezeichnung,
            value: "",
            date: item.eintragDatumDisplay,
            cssClass: "",
          };
        });

        setEquipmentImageData(tempArr);
        setSelectedEquipDetail(res);
        setDetailAttributeList(tempObj1);
        setTicketList(tempObj2);
        setMaintenanceList(tempObj3);
        setTag(res.tag);
        handleTourGuid(1);
      }
      setGlobalSpinner(false);
    }

    function handleError() {
      var res = tabsStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_SUCCESS,
      updateData,
    );

    tabsStore.addChangeListener(
      tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_FAILURE,
      handleError,
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_SUCCESS,
        updateData,
      );
      tabsStore.removeChangeListener(
        tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_FAILURE,
        handleError,
      );
    };
  }, []);

  useEffect(() => {
    if (
      equipGroupPublicWebConf.openTicketsCount >=
      equipGroupPublicWebConf.openTicketLimit
    ) {
      setIsMaxTicketLimitReach(true);
    } else {
      setIsMaxTicketLimitReach(false);
    }
    return () => {};
  }, [equipGroupPublicWebConf]);

  const ReusableButton = ({ label, icon, onClick }) => {
    return (
      <Button
        onClick={onClick}
        variant="outlined"
        startIcon={icon}
        disableRipple
        disableFocusRipple
        className="muibutton"
      >
        {label}
      </Button>
    );
  };
  const ViewAllImagesButton = () => {
    return (
      <Button
        onClick={() => {
          handleTabSelection(3);
        }}
        startIcon={<LuImage size={16} />}
        className="view-all-images-btn"
        disableRipple
        disableFocusRipple
        disableElevation
      >
        {localization.viewAllImages}
      </Button>
    );
  };

  const handleDownloadQRCode = () => {
    const qrCodeElement = qrCodeRef.current?.querySelector("svg");
    if (qrCodeElement) {
      const canvas = document.createElement("canvas");
      const svgData = new XMLSerializer().serializeToString(qrCodeElement);
      const img = new Image();
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        canvas.toBlob((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `QRCode_${selectedEquipDetail?.inventryNumber}_${tag}.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
      };
      img.src = "data:image/svg+xml;base64," + btoa(svgData);
    }
  };

  const mainAttrList = {
    title:
      localization.equipment +
      " #" +
      selectedEquipDetail?.inventryNumber +
      " " +
      localization.overview,
    description:
      selectedEquipDetail?.status?.toLowerCase() == "inbe"
        ? localization.equipmentIsIn +
          " " +
          localization.active +
          " " +
          localization.status
        : localization.equipmentIsIn +
          " " +
          localization.inActive +
          " " +
          localization.status,
    itemList: [
      {
        label: localization.status,
        value:
          selectedEquipDetail?.status?.toLowerCase() == "inbe"
            ? localization.active
            : localization.inActive,
        cssClass:
          selectedEquipDetail?.status?.toLowerCase() == "inbe"
            ? "activeStatusCls"
            : "inActiveStatusCls",
      },
      {
        label: localization.lastInspection,
        value: selectedEquipDetail?.lastCheckDate,
        cssClass: "",
      },
      {
        label: localization.nextInspection,
        value: selectedEquipDetail?.nextCheckDate,
        cssClass: "",
      },
    ],
  };

  const inspectionStatusList = {
    title: localization.inspectionStatus,
    description: localization.currentInspectionInfo,
    itemList: [
      {
        label: localization.lastInspection,
        value: selectedEquipDetail?.lastCheckDate,
        cssClass: "",
      },
      {
        label: localization.nextInspection,
        value: selectedEquipDetail?.nextCheckDate,
        cssClass: "",
      },
      {
        label: localization.status,
        value: selectedEquipDetail?.lastInspectionStatus
          ? localization.nio
          : localization.io,
        cssClass: selectedEquipDetail?.lastInspectionStatus
          ? "inActiveStatusCls"
          : "activeStatusCls",
      },
    ],
  };

  const handleSubmitCallback = () => {
    setOpenTicketModal(false);
    setGlobalSpinner(true);
    TabsActions.getEquipmentOverviewDetails(anlageid);
  };

  const handleAddMaintenanceCallback = () => {
    setOpenAddMaintenance(false);
    setGlobalSpinner(true);
    TabsActions.getEquipmentOverviewDetails(anlageid);
  };

  const reusableDisplayList = (listItem, listType) => {
    return (
      <>
        <Typography className="d-flex justifyContentSpaceBetw" component="div">
          <Typography gutterBottom variant="h4" component="div">
            {listItem.title}
          </Typography>
          {listType === "detailAttrList" && (
            <>
              <div>
                <EditOutlinedIcon
                  label={localization.editAttributes}
                  style={{ fontSize: "24px", cursor: "pointer" }}
                  onClick={() => {
                    setIsEdit(true);
                  }}
                />
              </div>
            </>
          )}
          {listType === "openTickets" &&
            equipGroupPublicWebConf?.canOpenTicket &&
            !isMaxTicketLimitReach && (
              <AddOutlinedIcon
                style={{ fontSize: "24px", cursor: "pointer" }}
                onClick={() => setOpenTicketModal(true)}
              />
            )}
          {listType === "upcomimgMaintenance" && (
            <AddOutlinedIcon
              style={{ fontSize: "24px", cursor: "pointer" }}
              onClick={() => {
                setOpenAddMaintenance(true);
              }}
            />
          )}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {listItem.description}
        </Typography>
        <Typography component="div" sx={{ color: "text.secondary" }}>
          <div className="equipDetailMainAttrList">
            {listItem.itemList.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`row ${
                    listType == "openTickets" ||
                    listType == "upcomimgMaintenance"
                      ? "listBorder"
                      : ""
                  }`}
                >
                  <div className="col labelColumn">
                    <div
                      className={`${
                        listType == "openTickets" ||
                        listType == "upcomimgMaintenance"
                          ? "boldTitle"
                          : ""
                      }`}
                    >
                      {item.label}
                    </div>
                    {item.Created && (
                      <div className="createdDate"> {item.Created}</div>
                    )}
                    {item.date && <div className="dateText">{item.date}</div>}
                  </div>
                  <div className="col equipDetailMainAttrValueList">
                    <div className={item.cssClass}>{item.value}</div>
                  </div>
                </div>
              );
            })}
            {listItem.itemList.length == 0 &&
              (listType === "openTickets" ||
                listType === "upcomimgMaintenance") && (
                <div className="text-center">{localization.noRecordFound}</div>
              )}
          </div>
        </Typography>
      </>
    );
  };

  return (
    <>
      <div className="container-fluid mt-4 card-container">
        <div className="row">
          <div className="col p-0 leftCol d-flex">
            <div className="col p-0 equipDetailImgContent">
              {equipImageData.length > 0 ? (
                <>
                  <CardMedia
                    image={
                      "data:image/jpg;base64," +
                      equipImageData[0].documentAsString
                    }
                    title=""
                  />
                </>
              ) : (
                <>
                  <div className="noImgCls">
                    {localization.noImageAvailable}
                  </div>
                </>
              )}
            </div>
            <div className="col">
              <CardContent>
                {reusableDisplayList(mainAttrList, "mainAttrList")}
              </CardContent>
              <CardActions sx={{ color: "text.secondary" }}>
                <div className="d-flex justifyContentSpaceBetw w-100">
                  {totalImageCount > 0 ? (
                    <span>
                      {totalImageCount} {localization.imagesAvailable}
                    </span>
                  ) : (
                    <span>{localization.noImagesAvailable}</span>
                  )}

                  <div className="Imagebutton">
                    <ViewAllImagesButton />
                  </div>
                </div>
              </CardActions>
            </div>
          </div>
          <div className="col-4 p-5 rightCol">
            <p className="text-center">{localization.publicwebsite}</p>
            {tag && tag !== "" ? (
              <div className="text-center">
                <div
                  id="QRCodeContainer"
                  ref={qrCodeRef}
                  className="text-center"
                >
                  <QRCodeSVG
                    value={`${window.location.origin}/#/public/search?tag=${tag}`}
                    size={200}
                    level="H"
                    includeMargin={true}
                  />
                </div>
                <div className="w-100 mt-1">
                  <ReusableButton
                    label={localization.downloadQRCode}
                    icon={<FileDownloadIcon size={18} />}
                    onClick={handleDownloadQRCode}
                  />
                </div>
              </div>
            ) : (
              <p className="mt-5 pt-5 text-center">
                {localization.noTagAvailable}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="container-fluid mt-4 ">
        <div className="row">
          <div className=" col p-5 leftCol card-container ">
            <div className="card-content">
              {reusableDisplayList(detailAttrList, "detailAttrList")}
            </div>
            <div className="w-100 ">
              <ReusableButton
                label={localization.editAttributes}
                icon={<EditOutlinedIcon size={18} />}
                onClick={() => {
                  setIsEdit(true);
                }}
              />
            </div>
          </div>

          <div className="col p-5 rightCol card-container">
            <div className="card-content">
              {reusableDisplayList(
                inspectionStatusList,
                "inspectionStatusList",
              )}
            </div>
            <div className="w-100 button-Container">
              <ReusableButton
                label={localization.viewChecklist}
                icon={<AssignmentOutlinedIcon size={18} />}
                onClick={() => {
                  setViewChecklist(true);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4 ">
        <div className="row">
          <div className=" col p-5 leftCol card-container ">
            <div className="card-content break-lines">
              {reusableDisplayList(tickeList, "openTickets")}
            </div>
            {equipGroupPublicWebConf?.canOpenTicket &&
              !isMaxTicketLimitReach && (
                <div className="w-100 ">
                  <ReusableButton
                    label={localization.createNewTicket}
                    icon={<ConfirmationNumberOutlinedIcon size={18} />}
                    onClick={() => {
                      setOpenTicketModal(true);
                    }}
                  />
                </div>
              )}
          </div>
          <div className="col p-5 rightCol card-container">
            <div className="card-content break-lines">
              {reusableDisplayList(maintenanceList, "upcomimgMaintenance")}
            </div>
            <div className="w-100 button-Container">
              <ReusableButton
                label={localization.addMaintenance}
                icon={<LuPenTool size={18} />}
                onClick={() => {
                  setOpenAddMaintenance(true);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {isEdit && (
        <Allgemein
          anlageid={anlageid}
          handleTourGuid={handleTourGuid}
          setIsEdit={setIsEdit}
        />
      )}
      {viewChecklist && (
        <ViewChecklist
          anlageid={anlageid}
          isOpen={viewChecklist}
          setViewChecklist={setViewChecklist}
        />
      )}
      {openTicketModal && (
        <FormTicketRaise
          open={openTicketModal}
          handleClose={() => setOpenTicketModal(false)}
          anlageid={anlageid}
          handleSubmitCallback={handleSubmitCallback}
        />
      )}
      {openAddMaintenance && (
        <AddMaintenance
          anlageid={anlageid}
          isOpen={openAddMaintenance}
          setOpenAddMaintenance={setOpenAddMaintenance}
          addMaintenanceCallBack={handleAddMaintenanceCallback}
        />
      )}
    </>
  );
};
export default EquipmentDetailOverview;
